import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ConstructionCard } from '../ConstructionCard/component.js';
import { PresentationCard } from '../presentation-card/component.js';
import { Layout } from '../../core/components/Layout/component.js';

var DashboardCard = function DashboardCard(_ref) {
  var constructionCardProps = _ref.constructionCardProps,
      emptyComponent = _ref.emptyComponent,
      getItemCardProps = _ref.getItemCardProps,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      title = _ref.title,
      type = _ref.type,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(Layout, {
    w: "360px",
    h: height,
    className: "card-fader-container ".concat(type, "-fader")
  }, /*#__PURE__*/React.createElement(ConstructionCard, _extends({
    size: "narrow",
    title: title,
    titleSize: 18,
    alwaysExpanded: true,
    className: "dashboard-card ".concat(type, "-card")
  }, constructionCardProps), !items.length ? /*#__PURE__*/React.createElement("div", {
    className: "empty-dashboard-card empty-".concat(type, "-card")
  }, emptyComponent) : items.map(function (item) {
    return /*#__PURE__*/React.createElement(PresentationCard, _extends({
      key: item.id,
      type: "mini",
      titleIconSize: "small",
      styleConfig: {
        corner: 'xsmall'
      }
    }, getItemCardProps(item)));
  })));
};

DashboardCard.displayName = "DashboardCard";
export { DashboardCard };